<template>
    <div class="d-flex">
        <ul class="star-xs__container list-unstyled d-flex my-2">
            <li v-for="(starNumber, starIndex) in 5" :key="starIndex" class="star-xs position-relative star-xs__container__item">
                <i class="ico ico--star-xs-inactive" />
                <div class="overflow-hidden position-absolute top-0 left-0">
                    <i :class="`ico ${starNumber > review.totalRating ? 'ico--star-xs-inactive' : 'ico--star-xs-active'}`" />
                </div>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Review from '~/models/ReviewClub/Review'

export default {
    props: {
        review: {
            type: Object as PropType<Review>,
            default: () => ({} as Review),
        },
    },
}
</script>

<style lang="scss" scoped>
.star-xs__container {
    background-color: $color-yellow-light;
    border-radius: 50px;
    padding: 4px 16px;
}
</style>
